import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const FitAndWell: Site = {
  id: 'fitandwell',
  logo: 'svg/fitandwell.svg',
  label: 'Fit&Well',
  analyticsName: 'fitandwell',
  hostname: 'fitandwell.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
